import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonList } from 'wsm-vehicle-cta-display';

class WidgetContainer extends React.Component {
	render() {
		return <ButtonList buttons={this.props.items} />;
	}
}

WidgetContainer.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const mapStateToProps = state => {
	return { items: state.items };
};

const mapDispatchToProps = _dispatch => {};

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx